<template>
  <div
    id="call-match-info-popup"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    :class="{'modal fade': true, 'show': open}"
    :style="modalStyle"
  >
    <div
      v-if="$props.enquiry"
      class="modal-dialog modal-lg"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header py-2 d-flex align-items-center">
          <h5 class="modal-title">
            {{ $t("Property.Enquiries.callMatchInfo.title") }}
          </h5>
          <button
            type="button"
            class="btn px-3 py-2"
            style="font-size: 24px;"
            @click="closeModal"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ $t( "Property.Enquiries.callMatchInfo.found", { count: propertyCount.toString() } ) }}</p>
          <table class="table table-striped">
            <tbody>
              <tr
                v-for="property in enquiry.Properties"
                :key="property.Id"
              >
                <td
                  class="align-middle img-col"
                >
                  <a
                    :href="getCallMatchPropertyURL( property.Id )"
                    target="_blank"
                    class="ratiobox__outer"
                  >
                    <template v-if="getFirstPhoto( property )">
                      <div class="ratiobox__ratio">
                        <div class="ratiobox__inner">
                          <img :src="photoUrl( getFirstPhoto( property ) )">
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <span class="img-cont">
                        <i class="la la-camera m--icon-font-size-lg3 d-block" />
                        <span class="d-block small">{{ $t('common.NoImages') }}</span>
                      </span>
                    </template>
                  </a>
                </td>
                <td class="align-middle">
                  <a
                    class="d-block"
                    :href="getCallMatchPropertyURL( property.Id )"
                    target="_blank"
                  >
                    {{ property.Id }}
                  </a>
                  <span class="d-block">{{ property.AgentRef }}</span>
                  <span
                    class="d-block"
                    v-html="showPrice( property )"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="open"
    class="modal-backdrop fade show"
  />
</template>
<script>
export default {
    props: {
        enquiry: {
            type: Object,
            required: false,
            default: null,
        },
    },
    emits: [
        'close',
    ],
    data() {
        return {
            open: false,
        };
    },
    computed: {
        propertyCount() {
            return this.$props.enquiry.Data.Match.propertyIDs.length;
        },
        modalStyle() {
            if ( !this.open ) {
                return '';
            }
            return 'padding-right: 15px; display: block;';
        },
    },
    watch: {
        enquiry: function( newVal, oldVal ) {
            if ( newVal ) {
                this.openModal();
            } else {
                this.closeModal();
            }
        },
    },
    methods: {
        showPrice( property ) {
            return this.$utils.showPrice( property );
        },
        getCallMatchPropertyURL( propertyID ) {
            let url = '';

            this.$props.enquiry.Data.Match.events.forEach( ( e ) => {
                if ( e.event.itemid === propertyID ) {
                    url = e.url;
                }
            } );

            const u = new URL( url );
            u.search = 'preview=1';
            u.hash = '';
            return u.toString();
        },
        getFirstPhoto( property ) {
            let photos = property.Photos;

            if ( !photos || photos.length === 0 ) {
                return null;
            }

            let photo = photos[ 0 ];

            for ( let p of photos ) {
                if ( p.Number < photo.Number ) {
                    photo = p;
                }
            }

            return photo;
        },
        photoUrl( photo ) {
            if ( !photo.CdnUrl ) {
                return photo.Url;
            }

            let url = photo.CdnUrl;
            let urlChunks = url.split( '/' );

            if ( urlChunks.length < 3 ) {
                return '';
            }

            // use https if http is returned
            if ( urlChunks[ 0 ] === 'http:' ) {
                urlChunks[ 0 ] = 'https:';
            }

            urlChunks.splice( urlChunks.length - 1, 0, 's400x300' );

            return urlChunks.join( '/' );
        },
        openModal() {
            document.body.classList.add( 'modal-open' );
            this.open = true;
        },
        closeModal() {
            document.body.classList.remove( 'modal-open' );
            this.open = false;
            this.$emit( 'close' );
        },
    },
};
</script>
<style lang="scss">
    .img-col {
        @media screen and (min-width: 768px) {
            width: 0;
        }
    }

    .ratiobox__outer {
        position: relative;
        display: block;

        @media screen and (min-width: 768px) {
            width: 200px;
        }
    }

    .ratiobox__ratio {
        padding-top: 75%;
        position: relative;
        display: block;
        width: 100%;
    }

    .ratiobox__inner {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        img {
            object-fit: cover;
            width: 100%;
            max-height: 100%;
            position: relative;
            height: 100%;
        }
    }
</style>
